<template>
  <div tabindex="-1" class="modal-content">
    <header class="modal-header bg-primary text-white">
      <h5 class="modal-title">
        {{ options.dialogTitle ? options.dialogTitle : "Pending Changes" }}
      </h5>
    </header>
    <div class="modal-body">
      <h6>{{ messageTitle }}</h6>
    </div>
    <footer class="modal-footer">
      <button
        @click="handleConfirm(true)"
        type="button"
        class="btn btn-primary"
      >
        {{ options.yesButtonTitle ? options.yesButtonTitle : "Save" }}
      </button>
      <button
        @click="handleConfirm(false)"
        type="button"
        class="btn bg-med-light-gray text-white"
      >
        {{ options.noButtonTitle ? options.noButtonTitle : "Discard" }}
      </button>
      <button
        @click="handleDismiss"
        type="button"
        class="btn bg-med-light-gray text-white"
      >
        Cancel
      </button>
    </footer>
  </div>
</template>

<script>
import DialogMixin from "vuejs-dialog/dist/vuejs-dialog-mixin.min.js"; // Include mixin

export default {
  name: "DialogConfirmUnsavedChaanges",
  mixins: [DialogMixin],
  methods: {
    handleConfirm(confirmValue) {
      this.proceed({ confirmValue }); // included in DialogMixin
    },
    handleDismiss() {
      this.cancel(); // included in DialogMixin
    }
  },
  components: {}
};
</script>

<style scoped="">
.modal-content {
  margin: -15px;
  width: auto;
}
</style>
